import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { NavService } from '../service/nav.service';

export const navGuard: CanActivateFn = (route, state) => {
  const navService = inject(NavService);
  const router = inject(Router);

  if (navService.isLoaded) {
    return true;
  }

  navService.requestedPage = state.url;
  router.navigateByUrl('init').then();
  return false;
};
